import styled from "styled-components";
import React from "react";
import {mdDown, mdDownN, xsDown} from "../ui/common";

const TitleBoxStyle = styled.div`
    position: relative;
    height: 75px;
    width: 598px;
    ${mdDownN`
        width: 100%;
        height: auto;
    `}
`;

const TitleStyle = styled.div`
    top: 26px;
    height: auto;
    width: 403px;
    position: absolute;
    margin: 0;
    left: 97px;
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 18.0px;
    color: rgba(10, 31, 68, 1.0);
    text-align: center;
    line-height: 25.0px;
    ${mdDownN`
        top: auto;
        width: 100%;
        position: relative;
        left:0;
        margin-top: ${props=>props.mt};
        margin-bottom: ${props=>props.mb};
        line-height:  ${props=>props.lh};
    `}
    ${xsDown`
        font-size: 16px;
    `}

`;

const TitleBox = (props) => {
    const marginTop = props.mt||'48px';
    const marginBottom = props.mb||'10px';
    const lineHeight = props.lh||'27px';
    return (
        <TitleBoxStyle>
            <TitleStyle mt={marginTop} mb={marginBottom} lh={lineHeight}>
                {props.children}
            </TitleStyle>
        </TitleBoxStyle>
    );
}

export default TitleBox;
